import { DocumentoAllegato } from './documento-allegato';
import { IntestazioneDocumento } from './documento/intestazione-documento';
import { PraticaLight } from './pratica/pratica-light';
import { Provenienza } from './tipologiche/provenienza';
import { TipoAtto } from './tipologiche/tipo-atto';

export class Atto {
  id: string;
  provenienza: Provenienza;
  tipoAtto: TipoAtto;
  dataDeposito: number;
  dataProtocollo: number;
  dataNotifica: number;
  dataApposizioneFormulaEsecutiva: number;
  dataPubblicazione: number;
  titoloEsecutivo: boolean;
  numeroProtocollo: number;
  note: string;
  documenti: DocumentoAllegato[];
  intestazione?: IntestazioneDocumento;
  entitaAssociate?: string[];
  praticaLight?: PraticaLight;
}
